import React from "react"
import { Link } from "react-router-dom"

import { EXTERNAL_ROUTE_PATHS } from "../utils/externalRoutes"

export const GetStartedExlusiveCodeComponent = () => {
  return (
    <section>
      <div className="container pt-5 pb-3 hero3">
        <div className="row no-gutters2 text-center">
          <div className="col">
            <h1 className="magenta exclusive-header font-teleNeoWeb">You scored a special <span style={{ "display": "inline-block" }}>T-Mobile</span> discount.</h1>
            <p >Enter your code to access amazing benefits. Then - visit <Link to={{ pathname: EXTERNAL_ROUTE_PATHS.TMO_JOIN }} target="_blank">Switch to T-Mobile</Link> to join us!</p>
          </div>
        </div>
      </div>
    </section>
  )
}
